import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the settlements state domain
 */

const selectSettlementsDomain = state => state.settlements || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Settlements
 */

const makeSelectSettlements = () =>
  createSelector(
    selectSettlementsDomain,
    substate => substate,
  );

export default makeSelectSettlements;
export { selectSettlementsDomain };
